import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { cookieCategories } from '../data/cookiePolicy';
import { useCookieConsent } from '../context/CookieConsentContext';

export default function CookieConsent() {
  const {
    hasAnswered,
    isPreferencesOpen,
    openPreferences,
    closePreferences,
    acceptAll,
    rejectOptional,
    savePreferences,
    preferences,
  } = useCookieConsent();

  const [draft, setDraft] = useState({
    functional: false,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    if (isPreferencesOpen) {
      setDraft({
        functional: preferences?.functional ?? false,
        analytics: preferences?.analytics ?? false,
        marketing: preferences?.marketing ?? false,
      });
    }
  }, [isPreferencesOpen, preferences]);

  const showBanner = !hasAnswered && !isPreferencesOpen;
  const showPreferences = isPreferencesOpen;

  if (!showBanner && !showPreferences) {
    return null;
  }

  return (
    <>
      {showBanner && (
        <div className="cookie-banner" role="dialog" aria-labelledby="cookie-banner-title">
          <div className="cookie-banner-inner container">
            <div className="cookie-banner-text">
              <h2 id="cookie-banner-title">Çerez Kullanımı</h2>
              <p>
                Web sitemizde deneyiminizi iyileştirmek, güvenliği sağlamak ve site
                kullanımını analiz etmek amacıyla çerezler kullanıyoruz. Zorunlu olmayan
                çerezler için tercihlerinizi yönetebilirsiniz. Detaylı bilgi için{' '}
                <Link to="/cerez-politikasi">Çerez Politikamızı</Link> inceleyebilirsiniz.
              </p>
            </div>
            <div className="cookie-banner-actions">
              <button type="button" className="btn btn-primary" onClick={acceptAll}>
                Çerezleri Kabul Et
              </button>
              <button type="button" className="btn btn-outline cookie-btn-light" onClick={rejectOptional}>
                Reddet
              </button>
              <button type="button" className="btn btn-ghost cookie-btn-light" onClick={openPreferences}>
                Çerez Tercihleri
              </button>
            </div>
          </div>
        </div>
      )}

      {showPreferences && (
        <div className="cookie-modal-backdrop" onClick={closePreferences}>
          <div
            className="cookie-modal"
            role="dialog"
            aria-labelledby="cookie-preferences-title"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="cookie-modal-header">
              <h2 id="cookie-preferences-title">Çerez Tercihleri</h2>
              <button
                type="button"
                className="cookie-modal-close"
                aria-label="Kapat"
                onClick={closePreferences}
              >
                ×
              </button>
            </div>

            <p className="cookie-modal-intro">
              Aşağıdan çerez kategorilerini yönetebilirsiniz. Zorunlu çerezler site
              işlevselliği için gereklidir ve devre dışı bırakılamaz.
            </p>

            <div className="cookie-category-list">
              {cookieCategories.map((category) => {
                const isEssential = category.required;
                const checked = isEssential
                  ? true
                  : draft[category.id as keyof typeof draft];

                return (
                  <label
                    key={category.id}
                    className={`cookie-category${isEssential ? ' cookie-category-required' : ''}`}
                  >
                    <div className="cookie-category-header">
                      <span className="cookie-category-name">{category.name}</span>
                      <input
                        type="checkbox"
                        checked={checked}
                        disabled={isEssential}
                        onChange={(event) => {
                          if (isEssential) return;
                          setDraft((current) => ({
                            ...current,
                            [category.id]: event.target.checked,
                          }));
                        }}
                      />
                    </div>
                    <p>{category.description}</p>
                  </label>
                );
              })}
            </div>

            <div className="cookie-modal-actions">
              <button type="button" className="btn btn-primary" onClick={() => savePreferences(draft)}>
                Tercihleri Kaydet
              </button>
              <button type="button" className="btn btn-outline" onClick={acceptAll}>
                Tümünü Kabul Et
              </button>
              <button type="button" className="btn btn-ghost" onClick={rejectOptional}>
                Zorunlu Olmayanları Reddet
              </button>
            </div>

            <p className="cookie-modal-footer">
              <Link to="/cerez-politikasi" onClick={closePreferences}>
                Çerez Politikası
              </Link>
            </p>
          </div>
        </div>
      )}
    </>
  );
}
